<template>
  <div id="item_shop">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-button type="default" round size="small" @click="onClickRight">{{ $t('title.shop') }}</van-button>
      </template>
    </van-nav-bar>
    <van-row class="item_shop">
      <van-col span="22" offset="1" class="item_shop_type">
        <van-row gutter="20">
          <van-col span="8" v-for="(item,i) in shop_list" :key="i" @click.native="hrefType(i)">
            <van-button round size="small" :color="active === i ? '#AE2CF1' : ''" block>{{ item.title }}</van-button>
          </van-col>
        </van-row>
      </van-col>
      <van-col span="24" class="item_shop_list">
        <van-col span="22" offset="1" class="item_shop_list_center"  v-if="active === 0">
          <van-row gutter="20">
            <van-col span="8" v-for="(t,j) in list" :key="j" @click.native="shop_show_btn(t,1)">
              <van-col span="24" class="item_shop_list_center_one">
                <van-col span="24" class="item_shop_list_center_one_img">
                  <img :src="t.title_img"/>
                </van-col>
                <van-col span="24" class="item_shop_my_list_center_one_title">{{ $t('column.due_date') }}</van-col>
                <van-col span="24" class="item_shop_my_list_center_one_coin">
                  <span>{{ t.end_date }}</span>
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_list_center" v-else>
          <van-row gutter="20">
            <van-col span="8" v-for="(ta,i) in list" :key="i" @click.native="shop_show_btn(ta,2)">
              <van-col span="24" class="item_shop_list_center_one">
                <van-col span="24" class="item_shop_list_avatar_frame_img">
                  <img :src="head_image"/>
                  <picture v-if="isWebP(ta.img)">
                    <source :srcset="ta.img" type="image/webp" >
                    <img :src="ta.img" class="item_shop_list_avatar_frame_webp" />
                  </picture>
                  <div :id='"popular_svga"+ta.id' class="item_shop_list_avatar_frame_svga" v-else></div>
                </van-col>
                <van-col span="24" class="item_shop_my_list_center_one_title">{{ $t('column.due_date') }}</van-col>
                <van-col span="24" class="item_shop_my_list_center_one_coin">
                  <span>{{ ta.end_date }}</span>
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-col>
      </van-col>
      <van-popup v-model="shop_show" round position="bottom" :style="{ minHeight: '30%' }" >
        <van-col span="24" class="item_shop_popup" @click.native="car_play(buy_one.img)" v-if="buy_one.shop_type === 1">
          <van-icon name="play-circle-o" class="item_shop_popup_icon"/>
          <img :src="buy_one.title_img"/>
        </van-col>
        <van-col span="24" class="item_shop_popup item_shop_list_avatar_frame_popup_img" v-else>
          <img :src="head_image"/>
          <picture v-if="isWebP(buy_one.img)">
            <source :srcset="buy_one.img" type="image/webp" >
            <img :src="buy_one.img" class="item_shop_list_avatar_frame_popup_webp" />
          </picture>
          <div :id='"popup_popular_svga"+buy_one.id' class="item_shop_list_avatar_frame_popup_svga" v-else></div>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_my_popup_time">
            {{ $t('column.due_date') }}: {{ buy_one.end_date }}
        </van-col>
        <van-col span="22" offset="1" class="item_shop_popup_btn">
          <van-button round color="#AE2CF1" block  @click="save_btn"> {{ buy_one.status == 1 ?  $t('other.close') : $t('btn.wear') }}</van-button>
        </van-col>
      </van-popup>
      <van-overlay :show="svgaShow" @click.native="svgaHide" class="car_svga_index">
        <div id="svgaBox" @click.stop="svgaHide"></div>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
import SVGA from "svgaplayerweb";
export default {
  data() {
    return {
      active: 0,
      shop_list: [
        { id:1, title: this.$t('column.Car'), 'img': require('../assets/img/item_shop_car.png')},
        { id:2, title: this.$t('column.avatar_frame'), 'img': require('../assets/img/avatar_frame.png')}
      ],
      document_title: '',
      list: [],
      svgaShow: false,
      shop_show: false,
      buy_one: {},
      select_id: 0,
      is_submit: true,
      head_image: ''
    }
  },
  created: function() {
    this.convert();
    this.document_title = this.$t('column.My_props')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    isWebP(url) {
      if (!url) return false
      // 去除查询参数和哈希
      const cleanUrl = url.split('?')[0].split('#')[0]
      // 获取扩展名
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'webp'
    },
    hrefType(i) {
      this.active = i
      this.list = []
      this.convert()
    },
    SVGA() {
      this.$nextTick(()=>{
        console.log(this.list)
        this.list.map((v,i)=>{
          //这里动态给ID，列表
          var player = new SVGA.Player('#popular_svga'+v.id);
          var parser = new SVGA.Parser('#popular_svga'+v.id);
          //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
          parser.load(v.img, function(videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          })
        })
      })
    },
    popup_popular_svga() {
      const val = this.buy_one
      console.log('dddddd')
      console.log(val)
      this.$nextTick(()=>{
        //这里动态给ID，列表
        const player1 = new SVGA.Player('#popup_popular_svga' + val.id);
        const parser1 = new SVGA.Parser('#popup_popular_svga' + val.id);
        console.log(val.img)
        //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
        parser1.load(val.img, function(videoItem1) {
          player1.setVideoItem(videoItem1);
          player1.startAnimation();
        })
      })
    },
    shop_show_btn(t,type) {
      this.buy_one = t
      this.buy_one.shop_type = type; // 1座驾 2头像框
      this.shop_show = true
      if(type === 2){
        this.popup_popular_svga()
      }
    },
    svgaHide() {
      this.svgaShow = false
    },
    save_btn() {
      if (this.is_submit === false) {
        return false
      }
      this.is_submit = false
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      let url = this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=open_close_car"
      if(this.buy_one.shop_type === 2){
        url = this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=open_close_avatar"
      }
      axios.get(url, {
        params: {
          user_id: uid,
          token: token,
          id: this.buy_one.id,
          status: this.buy_one.status == 1 ? 0 : 1
        }
      }).then(res => {
        this.is_submit = true
        console.log(res.data)
        this.shop_show = false
        if(res.data.status === 1){
          this.convert();
        }
        Toast(res.data.error)
      })
    },
    car_play(url) {
      this.svgaShow = true
      const _this= this
      this.$nextTick(() => {
        try {
          const player = new SVGA.Player('#svgaBox');
          const parser = new SVGA.Parser('#svgaBox');
          //注意，这里必须是服务器地址，否则报错
          parser.load(url, function(videoItem) {
            player.loops = 1;  // 设置循环播放次数是1
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(function(){
              _this.svgaShow = false
            });
          })
        } catch (error) {
          console.error(error);
        }
      })
    },
    onClickLeft() {
      // 拦截关闭h5
      this.$router.go(-1); // 返回上一页
    },
    onClickRight() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/item_shop', query: {uid: uid, token: token}})
    },
    convert() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      let url = this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=my_car"
      if (this.active === 1) {
        url = this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=my_avatar_frame"
      }
      axios.get(url, {
        params : {
          user_id: uid,
          token: token
        }
      }).then(res =>{
        console.log(res.data)
        this.list = res.data.data.list
        this.head_image = res.data.data.head_image
        this.select_id = res.data.data.select_id
        if (this.active === 1) {
          this.SVGA()
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item_shop_my.vue